'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'peach';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e20b';
var svgPathData = 'M144 0L80 0 80 32c0 22.3 5.7 43.2 15.7 61.5 10.2-3.9 20.8-7.1 31.7-9.3-9.7-15-15.4-32.9-15.4-52.1l32 0c39.8 0 73.9 24.2 88.5 58.6 8.1 2.8 16 6 23.5 9.7 7.6-3.7 15.5-7 23.5-9.7 14.6-34.4 48.7-58.6 88.5-58.6l32 0c0 19.2-5.6 37.1-15.4 52.1 10.9 2.3 21.5 5.4 31.7 9.3 10-18.2 15.7-39.2 15.7-61.5l0-32-64 0c-48.2 0-90.2 26.6-112 66-21.8-39.4-63.8-66-112-66zM336 280c0-48-20.1-91.3-52.4-121.9 18.2-9 38.7-14.1 60.4-14.1 75.1 0 136 60.9 136 136 0 57.4-49.4 107.1-112.7 145.7-45.4 27.7-91.7 45.6-111.3 52.5-19.6-6.9-66-24.9-111.3-52.5-63.2-38.5-112.7-88.2-112.7-145.7 0-75.1 60.9-136 136-136s136 60.9 136 136l32 0zM256 136.9C230.4 121.1 200.3 112 168 112 75.2 112 0 187.2 0 280 0 432 256 512 256 512s256-80 256-232c0-92.8-75.2-168-168-168-32.3 0-62.4 9.1-88 24.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPeach = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;